import React, { useEffect } from 'react'
import { DocumentationCard, withFade } from 'components'
import { ViewContainer } from './styles'
import Helmet from 'components/utilities/Helmet'
import { SCREEN_TITLES } from 'utils/navigation'

import useNavigation from 'hooks/useNavigation'
import SignedDocumentsCard from 'components/molecules/SignedDocumentsCard'
import { CompanyStatus } from 'utils/common'
import { useAppDispatch } from 'hooks/redux'
import { getMultiEnterpriseAssociations } from 'store/menu/thunks'
import { useSelector } from 'react-redux'
import MyEnterprisesSkeleton from 'assets/skeletons/MyEnterprisesSkeleton'
import { StatusType } from 'components/atoms/Status/constants'

export const CompanyStatusForCard = {
  [CompanyStatus.PENDING]: StatusType.PENDING,
  [CompanyStatus.APPROVED]: StatusType.APPROVED
}

const Documentation: React.FC = () => {
  const { onNavigate } = useNavigation()
  const dispatch = useAppDispatch()
  const { multiEnterpriseAssociation, isLoading } = useSelector(
    (state: any) => state.menu
  )

  useEffect(() => {
    dispatch(getMultiEnterpriseAssociations())
  }, [dispatch])

  const TOOLTIP_MESSAGE =
    'Para más información por favor ir a Atención al Cliente'

  if (isLoading) return <MyEnterprisesSkeleton />

  return (
    <ViewContainer>
      <Helmet title={SCREEN_TITLES.DOCUMENTATION} />
      {multiEnterpriseAssociation.map((element: any) => (
        <DocumentationCard
          key={element.id || element.businessName}
          title={
            element.legalType === 'FISICA'
              ? 'Validación de Identidad'
              : 'Documentación de la empresa'
          }
          description={element.businessName}
          status={
            CompanyStatusForCard[
              element.companyStatus as keyof typeof CompanyStatusForCard
            ]
          }
          hasTooltip
          labelTooltip={TOOLTIP_MESSAGE}
          margin={8}
        />
      ))}

      <SignedDocumentsCard
        title="Documentación"
        description="Firma electrónica"
        onClick={() => onNavigate('/content/documentation/signature')}
      />
    </ViewContainer>
  )
}

export default withFade(Documentation)
